/**************************************************************************************************************************************************
*   MODULE NAME     :  MasterData Actions
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  03-05-2021
*   DESCRIPTION     :  MasterData API actions
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import * as types from "./actionTypes";
import MasterDataApi from "../api/MasterDataApi";

/******* ACTION OBJECTS *******/


/*****  ACTION DISPATCHERS  ******/


export const loadAlertsEmailsMasterData = () => {
  return async () => {
    try {
      return await MasterDataApi.getMasterData();
    } catch (error) {
      throw error;
    }
  };
  
};
export const saveMasterData = (payload) => {
  return async () => {
    try {
      return await MasterDataApi.saveMasterData(payload);
    } catch (error) {
      throw error;
    }
  }
};
